import type {Distribution2D, _Distribution2D} from './distribution2-d';

/**
 * Generated from com.dataiku.dip.eda.compute.distributions.KDE2D
 */
export interface KDE2D extends _Distribution2D {
    x_relative_bandwidth: number;
    y_relative_bandwidth: number;

    // PolyJson type
    type: 'kde_2d';
}

export namespace KDE2D {
    export const type = 'kde_2d';
}

/** @deprecated Use Distribution2D.isKDE2D() */ export function isKDE2D(toTest: Distribution2D): toTest is KDE2D { return KDE2D.type === toTest['type']; }

export namespace KDE2D {
    /**
     * Generated from com.dataiku.dip.eda.compute.distributions.KDE2D$FittedKDE2D
     */
    export interface FittedKDE2D extends Distribution2D._FittedDistribution2D {
        // PolyJson type
        type: 'kde_2d';
    }

    export namespace FittedKDE2D {
        export const type = 'kde_2d';
    }

    /** @deprecated Use Distribution2D.FittedDistribution2D.isFittedKDE2D() */ export function isFittedKDE2D(toTest: Distribution2D.FittedDistribution2D): toTest is FittedKDE2D { return FittedKDE2D.type === toTest['type']; }
}